package dev.kuml.portal.web.i18n

/**
 * R-18: the two UI languages this portal supports. Deliberately a closed, two-value enum -- adding
 * a third language is a real project decision (a full [dev.kuml.portal.web.i18n.legal.LegalPages]
 * translation, a native reviewer for the legal pages, etc.), not something that should silently
 * fall out of a generic locale list.
 *
 * @property storageValue the exact `localStorage` value persisted by [LanguageStore] under its
 *   `"kportal.lang"` key -- also the only two values [LanguageStore.load] accepts back.
 * @property htmlLang the value applied to `document.documentElement.lang` (see [LanguageState]) --
 *   used by assistive technology to choose the correct pronunciation/hyphenation.
 * @property nativeLabel the language's own name IN that language, e.g. `"Deutsch"`/`"English"` --
 *   never translated (see [dev.kuml.portal.web.components.languageSwitcher]'s KDoc).
 * @property shortLabel the two-letter toggle label, `"DE"`/`"EN"`.
 */
public enum class Language(
    public val storageValue: String,
    public val htmlLang: String,
    public val nativeLabel: String,
    public val shortLabel: String,
) {
    DE(storageValue = "de", htmlLang = "de", nativeLabel = "Deutsch", shortLabel = "DE"),
    EN(storageValue = "en", htmlLang = "en", nativeLabel = "English", shortLabel = "EN"),
    ;

    public companion object {
        /** `null` for anything other than exactly [DE]'s or [EN]'s [storageValue] -- callers must
         * NOT silently coerce an unrecognised value; see [LanguageStore.load]'s KDoc for why. */
        public fun fromStorageValue(value: String?): Language? = entries.firstOrNull { it.storageValue == value }
    }
}
